import React from "react";

// Rich recharts tooltip used by server history charts (player count + ping).
// Shows the time window, players avg + peak, ping, online % and dominant map.
export const RichHistoryTooltip = ({ active, payload, bucket, metric = "players" }) => {
  if (!active || !payload || !payload.length) return null;
  const p = payload[0].payload;
  const windowLabel = p.endTime ? `${p.time} – ${p.endTime}` : p.time;
  return (
    <div
      className="font-mono-hud text-xs"
      style={{
        background: "var(--bg-elevated)",
        border: "1px solid var(--primary-accent)",
        borderRadius: 2,
        color: "var(--text-primary)",
        padding: "8px 10px",
        minWidth: 200,
      }}
      data-testid="rich-history-tooltip"
    >
      <div className="hud-caption mb-1">{windowLabel} · {bucket} MIN</div>
      <Row label="Players" value={`avg ${p.players} · peak ${p.peak_players}`} valueColor="var(--primary-accent)" highlight={metric === "players"} />
      <Row label="Ping" value={`${p.ping}ms`} valueColor={metric === "ping" ? "var(--primary-accent)" : "var(--text-primary)"} highlight={metric === "ping"} />
      <Row
        label="Online"
        value={`${p.online_pct}%`}
        valueColor={
          p.online_pct >= 100 ? "var(--highlight)"
          : p.online_pct > 0 ? "var(--text-primary)"
          : "var(--ping-high)"
        }
      />
      {p.map && (
        <Row label="Map" value={p.map} valueColor="var(--secondary-accent)" />
      )}
    </div>
  );
};

const Row = ({ label, value, valueColor, highlight }) => (
  <div
    className="flex items-center justify-between gap-6"
    style={{ fontWeight: highlight ? 700 : 400 }}
  >
    <span style={{ color: "var(--text-dim)" }}>{label}</span>
    <span className="tabular-nums" style={{ color: valueColor }}>{value}</span>
  </div>
);

export default RichHistoryTooltip;
